export default function littleHint(
  txt = '',
  opt = { delay: 2000, classname: '' }
) {
  const firstclass = 'newsHint'
  let dom = document.querySelector('.' + firstclass)
  if (!dom) {
    dom = document.createElement('div')
    dom.className = `${firstclass} ${opt.classname}`
    dom.style.zIndex = 9999
    document.body.appendChild(dom)
  }
  let o = {
    open: () => {
      clearTimeout(dom.timer)
      dom.innerHTML = txt
      dom.style.display = ''
      if (opt.delay)
        dom.timer = setTimeout(() => {
          dom.style.display = 'none'
        }, opt.delay) // delay为0则长期显示
      return o
    },
    close: () => {
      clearTimeout(dom.timer)
      dom.style.display = 'none'
      return o
    }
  }
  return o.open()
}



// WEBPACK FOOTER //
// ./src/cmtapp/heaperJs/wg-littleHint.js